import { render, staticRenderFns } from "./SectionFields.vue?vue&type=template&id=2766a644&scoped=true&"
import script from "./SectionFields.vue?vue&type=script&lang=js&"
export * from "./SectionFields.vue?vue&type=script&lang=js&"
import style0 from "./SectionFields.vue?vue&type=style&index=0&id=2766a644&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2766a644",
  null
  
)

export default component.exports